import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { marketService } from '../services/marketService';

const HomePage = () => {
  const [stats, setStats] = useState({
    activeIPOs: 0,
    totalIssueSize: '₹0 Cr',
    avgListingGains: '0%'
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const data = await marketService.getHomeStats();
        setStats(data);
      } catch (error) {
        console.error('Failed to fetch stats:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
    const interval = setInterval(fetchStats, 30000); // Update every 30 seconds
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-600 via-purple-600 to-indigo-800">
      <nav className="bg-white/10 backdrop-blur-md border-b border-white/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="text-xl md:text-2xl font-bold text-white">
              IPO Tracker
            </div>
            <div className="hidden md:flex space-x-8">
              <Link to="/" className="bg-white/20 text-white px-4 py-2 rounded-full text-sm font-medium">
                Home
              </Link>
              <Link to="/market-watch" className="text-white/80 hover:text-white px-4 py-2 rounded-full text-sm font-medium transition-colors">
                Market Watch
              </Link>
              <Link to="/ipos" className="text-white/80 hover:text-white px-4 py-2 rounded-full text-sm font-medium transition-colors">
                IPOs
              </Link>
            </div>
            <div className="md:hidden">
              <Link to="/market-watch" className="text-white/80 hover:text-white p-2">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </nav>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
            Track IPO <span className="bg-gradient-to-r from-yellow-400 to-orange-500 bg-clip-text text-transparent">Investments</span>
          </h1>
          <p className="text-lg md:text-xl text-white/90 mb-8 max-w-2xl mx-auto px-4">
            Stay updated with the latest IPO launches and market performance with real-time data
          </p>
          <Link to="/ipos" className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-green-500 to-emerald-600 text-white font-semibold rounded-full hover:from-green-600 hover:to-emerald-700 transform hover:scale-105 transition-all duration-200 shadow-lg">
            View All IPOs
            <svg className="ml-2 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
            </svg>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-white/10 backdrop-blur-md rounded-3xl p-8 text-center border border-white/20 hover:bg-white/15 transition-all duration-300">
            <div className="text-4xl font-bold text-white mb-2">
              {loading ? (
                <div className="animate-pulse bg-white/20 h-10 rounded"></div>
              ) : (
                stats.activeIPOs
              )}
            </div>
            <p className="text-white/80 text-lg">Active IPOs</p>
          </div>
          <div className="bg-white/10 backdrop-blur-md rounded-3xl p-8 text-center border border-white/20 hover:bg-white/15 transition-all duration-300">
            <div className="text-4xl font-bold text-white mb-2">
              {loading ? (
                <div className="animate-pulse bg-white/20 h-10 rounded"></div>
              ) : (
                stats.totalIssueSize
              )}
            </div>
            <p className="text-white/80 text-lg">Total Issue Size</p>
          </div>
          <div className="bg-white/10 backdrop-blur-md rounded-3xl p-8 text-center border border-white/20 hover:bg-white/15 transition-all duration-300">
            <div className="text-4xl font-bold text-white mb-2">
              {loading ? (
                <div className="animate-pulse bg-white/20 h-10 rounded"></div>
              ) : (
                stats.avgListingGains
              )}
            </div>
            <p className="text-white/80 text-lg">Avg. Listing Gains</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;